function setCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toUTCString() + '; path=/';
}

function getCookie(cookieName) {
    var name = cookieName + '=';
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name) === 0)
            return temp.substring(name.length, temp.length);
    }
    return null;
}

$(document).ready(function () {
    
    var initMenuOverrides = function () {

        var $navbarToggler = $('button.navbar-toggler');
        var $navbar = $($navbarToggler.attr('data-target'));

        // When toggling menu (normally mobile menu), lookup active items
        // and add trigger 'show' in order to expand dropdown menus (if any)
        $navbarToggler.on('click.furillo', function (e) {

            // When desktop or when closing there's no need to run this
            if (!$navbarToggler.is(':visible') || $(this).attr('aria-expanded') === 'true') {
                return;
            }

            $('.nav-item.dropdown.active', $navbar).each(function () {
                $('.collapse', $(this)).first().collapse('show');
            });
        });

        // Since we use BS 'collapse' rather than 'dropdown' for menu we need
        // to add this to close all open collapses when clicking outside of the menu.
        $(document).on('click.furillo', function (e) {

            // If on mobile or still within the navbar, no need to run this
            if ($navbarToggler.is(':visible') || $(e.target).parents('.navbar').length > 0)
                return;

            $('.nav-item .collapse.show').collapse('hide');
        });


        var timeoutId = null;
        $navbar.on('mouseover.furillo', '.nav-item.dropdown', function (e) {

            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            var $this = $(this);

            // If already open (like the parent), no need to run
            if ($('.collapse.show', $this).first().length > 0) {
                return;
            }

            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(function () {
                $('.collapse', $this).first().collapse('show');

                // Always only one open
                $this.siblings('.nav-item.dropdown').each(function () {
                    $('.collapse.show', this).first().collapse('hide');
                });

                timeoutId = null;
            }, 250);
        });

        $navbar.on('mouseleave.furillo', '.nav-item.dropdown', function (e) {

            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            $('.collapse.show', this).first().collapse('hide');
        });
    };

    initMenuOverrides();

    $(document).on('click', '[data-toggle="lightbox"]', function (e) {
        e.preventDefault();
        $(this).ekkoLightbox({
            showArrows: true
        });
    });
    
    $('.site-header .alert').on('close.bs.alert', function () {

        var id = parseInt($(this).data('id'));
        if (isNaN(id))
            return;

        var cookie = getCookie('read_messages');
        var messages = [];
        if (cookie && cookie.length > 0) {
            messages = cookie.split('|');
        }

        messages.push(id);
        
        // Apply setCookie
        setCookie('read_messages', messages.join('|'), 7);
    });

    $('.tag-filters').tagfilter();
    $('body').noreferrer();
    $('body').sharelinks();
    $('[data-toggle="tooltip"]').tooltip()
});


$(function () {
    
    var animateBlockNumbers = function () {

        var isElementInViewport = function(el) {
            
            if (typeof jQuery === "function" && el instanceof jQuery) {
                el = el[0];
            }

            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <=
                    (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        };

        $('.block-number .number').each(function () {
            var $this = $(this);
            var number = parseInt($this.data('number'), 10);
            if (parseInt($this.text(), 10) === number) {
                return true;
            }

            if (!isElementInViewport($this)) {
                return true;
            }

            var props = {
                "from": {
                    "count": 0
                },
                "to": {
                    "count": number
                }
            };

            $(props.from).animate(props.to, {
                duration: 1000 * 1,
                step: function (now) {
                    $this.text(Math.ceil(now));
                },
                complete: function () {
                    $this.text($this.data('number'));
                }
            });
        });
    };

    $(window).on('DOMContentLoaded load resize scroll', animateBlockNumbers);
});
